export type IconPathProps = {
  strokeLinejoin?: 'miter' | 'round' | 'bevel' | 'inherit';
  strokeLinecap?: 'round' | 'inherit' | 'butt' | 'square';
  strokeMiterlimit?: string;
  strokeWidth?: string;
  haveFill?: boolean;
  d: string;
};

export type IconDefinitionProps = {
  viewBoxWidth: number;
  viewBoxHeight: number;
  paths: IconPathProps[];
};

export type IconDefinitionSetProps = {
  [key: string]: IconDefinitionProps;
};

const iconDefinition = {
  arrowDownAcura: {
    viewBoxWidth: 52,
    viewBoxHeight: 32,
    paths: [
      {
        strokeLinejoin: 'miter',
        strokeLinecap: 'square',
        strokeMiterlimit: '4',
        strokeWidth: '8',
        d: 'M46 6l-20 20-20-20',
      },
    ],
  },
  arrowDownHonda: {
    viewBoxWidth: 57,
    viewBoxHeight: 32,
    paths: [
      {
        strokeLinejoin: 'round',
        strokeLinecap: 'round',
        strokeMiterlimit: '8',
        strokeWidth: '8',
        d: 'M52.25 4l-24 24-24-24',
      },
    ],
  },
  arrowRightAcura: {
    viewBoxWidth: 20,
    viewBoxHeight: 32,
    paths: [
      {
        strokeLinejoin: 'miter',
        strokeLinecap: 'square',
        strokeMiterlimit: '4',
        strokeWidth: '4.5714',
        d: 'M3.5 3.5l12.5 12.5-12.5 12.5',
      },
    ],
  },
  arrowRightHonda: {
    viewBoxWidth: 19,
    viewBoxHeight: 32,
    paths: [
      {
        strokeLinejoin: 'round',
        strokeLinecap: 'round',
        strokeMiterlimit: '4',
        strokeWidth: '4.9231',
        d: 'M2.594 2.5l13.5 13.5-13.5 13.5',
      },
    ],
  },
  block: {
    viewBoxWidth: 32,
    viewBoxHeight: 32,
    paths: [
      {
        strokeLinejoin: 'miter',
        strokeLinecap: 'butt',
        strokeMiterlimit: '4',
        strokeWidth: '2.25',
        d: 'M5.455 5.585l20.833 20.833',
      },
      {
        strokeLinejoin: 'miter',
        strokeLinecap: 'butt',
        strokeMiterlimit: '4',
        strokeWidth: '2.25',
        d: 'M30.5 16c0 8.008-6.492 14.5-14.5 14.5s-14.5-6.492-14.5-14.5c0-8.008 6.492-14.5 14.5-14.5s14.5 6.492 14.5 14.5z',
      },
    ],
  },
  get blockAcura() {
    return this.block;
  },
  get blockHonda() {
    return this.block;
  },
  boltAcura: {
    viewBoxWidth: 18,
    viewBoxHeight: 32,
    paths: [
      {
        d: 'M7.214 32h-1.778l1.778-12.444h-6.222c-1.565 0-0.587-1.333-0.551-1.387 2.293-4.053 5.742-10.098 10.347-18.169h1.778l-1.778 12.444h6.24c0.711 0 1.102 0.338 0.711 1.173-7.022 12.249-10.524 18.382-10.524 18.382z',
      },
    ],
  },
  boltOutlinedAcura: {
    viewBoxWidth: 21,
    viewBoxHeight: 32,
    paths: [
      {
        stroke: 'currentColor',
        fill: 'none',
        strokeLinejoin: 'round',
        strokeLinecap: 'butt',
        strokeMitterlimit: '4',
        strokeWidth: '2.25',
        d: 'M 2.9 18.4 C 5.1 14.5 8.2 9 12.4 1.6 L 10.7 13.6 H 17.7 C 14.3 19.4 11.8 23.9 10.1 26.8 C 9.2 28.4 8.6 29.5 8.1 30.3 L 9.8 18.4 H 2.9 Z',
      },
    ],
  },
  doubleBolt: {
    viewBoxWidth: 39,
    viewBoxHeight: 32,
    paths: [
      {
        d: 'M26.97 32h-1.799l1.799-12.444h-6.297c-1.583 0-0.594-1.333-0.558-1.387 2.321-4.053 5.811-10.098 10.471-18.169h1.799l-1.799 12.444h6.315c0.72 0 1.115 0.338 0.72 1.173-7.106 12.249-10.651 18.382-10.651 18.382z',
      },
      {
        d: 'M7.193 32h-1.799l1.799-12.444h-6.297c-1.583 0-0.594-1.333-0.558-1.387 2.321-4.053 5.811-10.098 10.471-18.169h1.799l-1.799 12.444h6.315c0.72 0 1.115 0.338 0.72 1.173-7.106 12.249-10.651 18.382-10.651 18.382z',
      },
    ],
  },
  get doubleBoltAcura() {
    return this.doubleBolt;
  },
  get doubleBoltHonda() {
    return this.doubleBolt;
  },
  tripleBolt: {
    viewBoxWidth: 58,
    viewBoxHeight: 32,
    paths: [
      {
        d: 'M26.97 32h-1.799l1.799-12.444h-6.297c-1.583 0-0.594-1.333-0.558-1.387 2.321-4.053 5.811-10.098 10.471-18.169h1.799l-1.799 12.444h6.315c0.72 0 1.115 0.338 0.72 1.173-7.106 12.249-10.651 18.382-10.651 18.382z',
      },
      {
        d: 'M46.748 32h-1.799l1.799-12.444h-6.297c-1.583 0-0.594-1.333-0.558-1.387 2.321-4.053 5.811-10.098 10.471-18.169h1.799l-1.799 12.444h6.315c0.72 0 1.115 0.338 0.72 1.173-7.106 12.249-10.651 18.382-10.651 18.382z',
      },
      {
        d: 'M7.193 32h-1.799l1.799-12.444h-6.297c-1.583 0-0.594-1.333-0.558-1.387 2.321-4.053 5.811-10.098 10.471-18.169h1.799l-1.799 12.444h6.315c0.72 0 1.115 0.338 0.72 1.173-7.106 12.249-10.651 18.382-10.651 18.382z',
      },
    ],
  },
  get tripleBoltAcura() {
    return this.tripleBolt;
  },
  get tripleBoltHonda() {
    return this.tripleBolt;
  },
  checkAcura: {
    viewBoxWidth: 42,
    viewBoxHeight: 32,
    paths: [
      {
        strokeLinejoin: 'miter',
        strokeLinecap: 'square',
        strokeMiterlimit: '4',
        strokeWidth: '4',
        d: 'M38.8 3.286l-25.082 25.429-10.518-10.902',
      },
    ],
  },
  checkHonda: {
    viewBoxWidth: 43,
    viewBoxHeight: 32,
    paths: [
      {
        strokeLinejoin: 'round',
        strokeLinecap: 'round',
        strokeMiterlimit: '4',
        strokeWidth: '6',
        d: 'M39.59 3.157l-25.688 25.685-10.772-11.012',
      },
    ],
  },
  circleCheck: {
    viewBoxWidth: 32,
    viewBoxHeight: 32,
    paths: [
      {
        strokeLinejoin: 'miter',
        strokeLinecap: 'square',
        strokeMiterlimit: '4',
        strokeWidth: '2',
        d: 'M24.084 11.606l-9.387 9.667-4.673-4.521',
      },
      {
        strokeLinejoin: 'miter',
        strokeLinecap: 'butt',
        strokeMiterlimit: '4',
        strokeWidth: '2',
        d: 'M30.75 16c0 8.008-6.492 14.5-14.5 14.5s-14.5-6.492-14.5-14.5c0-8.008 6.492-14.5 14.5-14.5s14.5 6.492 14.5 14.5z',
      },
    ],
  },
  get circleCheckAcura() {
    return this.circleCheck;
  },
  get circleCheckHonda() {
    return this.circleCheck;
  },
  circleMinus: {
    viewBoxWidth: 32,
    viewBoxHeight: 32,
    paths: [
      {
        strokeLinejoin: 'round',
        strokeLinecap: 'round',
        strokeMiterlimit: '4',
        strokeWidth: '2',
        d: 'M21.273 16h-9.666',
      },
      {
        strokeLinejoin: 'miter',
        strokeLinecap: 'butt',
        strokeMiterlimit: '4',
        strokeWidth: '2',
        d: 'M30.5 16c0 8.008-6.492 14.5-14.5 14.5s-14.5-6.492-14.5-14.5c0-8.008 6.492-14.5 14.5-14.5s14.5 6.492 14.5 14.5z',
      },
    ],
  },
  get circleMinusAcura() {
    return this.circleMinus;
  },
  get circleMinusHonda() {
    return this.circleMinus;
  },
  closeAcura: {
    viewBoxWidth: 32,
    viewBoxHeight: 32,
    paths: [
      {
        strokeLinejoin: 'miter',
        strokeLinecap: 'square',
        strokeMiterlimit: '4',
        strokeWidth: '3.5556',
        d: 'M29.5 2.5l-27 27',
      },
      {
        strokeLinejoin: 'miter',
        strokeLinecap: 'square',
        strokeMiterlimit: '4',
        strokeWidth: '3.5556',
        d: 'M2.5 2.5l27 27',
      },
    ],
  },
  closeHonda: {
    viewBoxWidth: 32,
    viewBoxHeight: 32,
    paths: [
      {
        strokeLinejoin: 'miter',
        strokeLinecap: 'round',
        strokeMiterlimit: '4',
        strokeWidth: '3.7647',
        d: 'M30.125 1.937l-28.125 28.125',
      },
      {
        strokeLinejoin: 'miter',
        strokeLinecap: 'round',
        strokeMiterlimit: '4',
        strokeWidth: '3.7647',
        d: 'M2 1.937l28.125 28.125',
      },
    ],
  },
  cross: {
    viewBoxWidth: 32,
    viewBoxHeight: 32,
    paths: [
      {
        strokeLinejoin: 'miter',
        strokeLinecap: 'round',
        strokeMiterlimit: '4',
        strokeWidth: '2.7826',
        d: 'M15.795 1.703v28.594',
      },
      {
        strokeLinejoin: 'miter',
        strokeLinecap: 'round',
        strokeMiterlimit: '4',
        strokeWidth: '2.7826',
        d: 'M1.5 16h28.594',
      },
    ],
  },
  get crossAcura() {
    return this.cross;
  },
  get crossHonda() {
    return this.cross;
  },
  document: {
    viewBoxWidth: 25,
    viewBoxHeight: 32,
    paths: [
      {
        d: 'M24.441 5.976l-6.025-5.976h-18.356v32h24.381v-26.024zM17.668 1.989l4.767 4.74h-4.767v-4.74zM2.007 30.069v-28.137h13.713v6.729h6.773v21.408h-20.486zM4.85 24.498h14.8v1.931h-14.8v-1.931zM4.85 20.214h14.8v1.931h-14.8v-1.931zM4.85 15.934h14.8v1.931h-14.8v-1.931zM4.85 11.654h14.8v1.931h-14.8v-1.931z',
      },
    ],
  },
  get documentAcura() {
    return this.document;
  },
  get documentHonda() {
    return this.document;
  },
  download: {
    viewBoxWidth: 32,
    viewBoxHeight: 32,
    paths: [
      {
        d: 'M18.286 3.589c0-1.262-1.023-2.286-2.286-2.286s-2.286 1.023-2.286 2.286h4.571zM16 21.549l-1.616 1.616c0.893 0.893 2.34 0.893 3.233 0l-1.616-1.616zM25.616 15.165c0.893-0.893 0.893-2.34 0-3.232s-2.34-0.893-3.232 0l3.232 3.232zM9.616 11.933c-0.893-0.893-2.34-0.893-3.232 0s-0.893 2.34 0 3.232l3.232-3.232zM4.571 21.549c0-1.262-1.023-2.286-2.286-2.286s-2.286 1.023-2.286 2.286h4.571zM2.286 28.406h-2.286v2.286h2.286v-2.286zM29.714 28.406v2.286h2.286v-2.286h-2.286zM32 21.549c0-1.262-1.023-2.286-2.286-2.286s-2.286 1.023-2.286 2.286h4.571zM13.714 3.589v17.96h4.571v-17.96h-4.571zM17.616 23.165l8-8-3.232-3.232-8 8 3.232 3.232zM17.616 19.933l-8-8-3.232 3.232 8 8 3.232-3.232zM0 21.549v6.857h4.571v-6.857h-4.571zM2.286 30.692h27.429v-4.571h-27.429v4.571zM32 28.406v-6.857h-4.571v6.857h4.571z',
      },
    ],
  },
  get downloadAcura() {
    return this.download;
  },
  get downloadHonda() {
    return this.download;
  },
  globe: {
    viewBoxWidth: 32,
    viewBoxHeight: 32,
    paths: [
      {
        strokeLinejoin: 'round',
        strokeLinecap: 'butt',
        strokeMiterlimit: '4',
        strokeWidth: '2.5452',
        d: 'M19.309 29.76c7.6-1.827 12.279-9.47 10.452-17.069s-9.47-12.279-17.070-10.452-12.279 9.47-10.452 17.070c1.827 7.6 9.47 12.279 17.070 10.452z',
      },
      {
        strokeLinejoin: 'round',
        strokeLinecap: 'butt',
        strokeMiterlimit: '4',
        strokeWidth: '2.5452',
        d: 'M15.997 30.157c3.722 0 6.739-6.337 6.739-14.153s-3.017-14.153-6.739-14.153-6.739 6.336-6.739 14.153c0 7.816 3.017 14.153 6.739 14.153z',
      },
      {
        strokeLinejoin: 'round',
        strokeLinecap: 'butt',
        strokeMiterlimit: '4',
        strokeWidth: '2.5452',
        d: 'M15.999 1.847v28.306',
      },
      {
        strokeLinejoin: 'round',
        strokeLinecap: 'butt',
        strokeMiterlimit: '4',
        strokeWidth: '2.5452',
        d: 'M30.15 16.003h-28.306',
      },
      {
        strokeLinejoin: 'round',
        strokeLinecap: 'butt',
        strokeMiterlimit: '4',
        strokeWidth: '2.5452',
        d: 'M26.781 6.893c-2.595 1.456-6.463 2.372-10.783 2.372s-8.188-0.923-10.783-2.372',
      },
      {
        strokeLinejoin: 'round',
        strokeLinecap: 'butt',
        strokeMiterlimit: '4',
        strokeWidth: '2.5452',
        d: 'M26.781 25.116c-2.595-1.456-6.463-2.372-10.783-2.372s-8.188 0.923-10.783 2.372',
      },
    ],
  },
  get globeAcura() {
    return this.globe;
  },
  get globeHonda() {
    return this.globe;
  },
  hamburguerAcura: {
    viewBoxWidth: 39,
    viewBoxHeight: 32,
    paths: [
      {
        strokeLinejoin: 'miter',
        strokeLinecap: 'square',
        strokeMiterlimit: '4',
        strokeWidth: '3.5556',
        d: 'M1.9 2.056h35.325',
      },
      {
        strokeLinejoin: 'miter',
        strokeLinecap: 'square',
        strokeMiterlimit: '4',
        strokeWidth: '3.5556',
        d: 'M1.9 16h35.325',
      },
      {
        strokeLinejoin: 'miter',
        strokeLinecap: 'square',
        strokeMiterlimit: '4',
        strokeWidth: '3.5556',
        d: 'M1.9 29.944h35.325',
      },
    ],
  },
  hamburguerHonda: {
    viewBoxWidth: 49,
    viewBoxHeight: 32,
    paths: [
      {
        strokeLinejoin: 'miter',
        strokeLinecap: 'round',
        strokeMiterlimit: '4',
        strokeWidth: '4.5',
        d: 'M2.523 1.748h43.772',
      },
      {
        strokeLinejoin: 'miter',
        strokeLinecap: 'round',
        strokeMiterlimit: '4',
        strokeWidth: '4.5',
        d: 'M2.523 16h43.772',
      },
      {
        strokeLinejoin: 'miter',
        strokeLinecap: 'round',
        strokeMiterlimit: '4',
        strokeWidth: '4.5',
        d: 'M2.523 30.252h43.772',
      },
    ],
  },
  info: {
    viewBoxWidth: 33,
    viewBoxHeight: 32,
    paths: [
      {
        strokeLinejoin: 'miter',
        strokeLinecap: 'butt',
        strokeMiterlimit: '4',
        strokeWidth: '1.8824',
        d: 'M31.309 16c0 8.317-6.742 15.059-15.059 15.059s-15.059-6.742-15.059-15.059c0-8.317 6.742-15.059 15.059-15.059s15.059 6.742 15.059 15.059z',
      },
      {
        d: 'M18.299 25.012h-2.578v-13.001h2.578v13.001zM18.737 7.32c0 0.475-0.174 0.869-0.521 1.179-0.329 0.311-0.731 0.466-1.207 0.466s-0.878-0.155-1.207-0.466c-0.329-0.329-0.494-0.722-0.494-1.179 0-0.475 0.165-0.869 0.494-1.179 0.329-0.329 0.731-0.494 1.207-0.494s0.878 0.165 1.207 0.494c0.347 0.311 0.521 0.704 0.521 1.179z',
      },
    ],
  },
  get infoAcura() {
    return this.info;
  },
  get infoHonda() {
    return this.info;
  },
  lock: {
    viewBoxWidth: 25,
    viewBoxHeight: 32,
    paths: [
      {
        d: 'M21.25 10.667h-1.5v-3.048c0-4.206-3.36-7.619-7.5-7.619s-7.5 3.413-7.5 7.619v3.048h-1.5c-1.65 0-3 1.371-3 3.048v15.238c0 1.676 1.35 3.048 3 3.048h18c1.65 0 3-1.371 3-3.048v-15.238c0-1.676-1.35-3.048-3-3.048zM7.75 7.619c0-2.529 2.010-4.571 4.5-4.571s4.5 2.042 4.5 4.571v3.048h-9v-3.048zM21.25 28.952h-18v-15.238h18v15.238zM12.25 24.381c1.65 0 3-1.371 3-3.048s-1.35-3.048-3-3.048c-1.65 0-3 1.371-3 3.048s1.35 3.048 3 3.048z',
      },
    ],
  },
  get lockAcura() {
    return this.lock;
  },
  get lockHonda() {
    return this.lock;
  },
  link: {
    viewBoxWidth: 61,
    viewBoxHeight: 32,
    paths: [
      {
        strokeLinejoin: 'miter',
        strokeLinecap: 'round',
        strokeMiterlimit: '10',
        strokeWidth: '6',
        d: 'M19.002 16h22.84',
      },
      {
        strokeLinejoin: 'miter',
        strokeLinecap: 'round',
        strokeMiterlimit: '4',
        strokeWidth: '6',
        d: 'M22.265 2.948h-6.526c-7.208 0-13.052 5.843-13.052 13.052v0c0 7.208 5.843 13.052 13.052 13.052h6.526',
      },
      {
        strokeLinejoin: 'miter',
        strokeLinecap: 'round',
        strokeMiterlimit: '4',
        strokeWidth: '6',
        d: 'M38.579 29.052h6.526c7.208 0 13.052-5.843 13.052-13.052v0c0-7.208-5.843-13.052-13.052-13.052h-6.526',
      },
    ],
  },
  get linkAcura() {
    return this.link;
  },
  get linkHonda() {
    return this.link;
  },
  mailAcura: {
    viewBoxWidth: 48,
    viewBoxHeight: 32,
    paths: [
      {
        d: 'M-0 32h48v-32h-48v32zM8.057 6.936l15.943 12.592 15.943-12.592 2.211 2.448-18.154 14.336-18.154-14.336 2.212-2.448z',
      },
    ],
  },
  mailHonda: {
    viewBoxWidth: 42,
    viewBoxHeight: 32,
    paths: [
      {
        strokeLinejoin: 'miter',
        strokeLinecap: 'butt',
        strokeMiterlimit: '4',
        strokeWidth: '1.1733',
        haveFill: true,
        d: 'M35.975 0.754h-29.794c-2.995 0-5.431 2.376-5.431 5.296v19.9c0 2.92 2.436 5.296 5.431 5.296h29.794c2.995 0 5.431-2.376 5.431-5.296v-19.9c0-2.92-2.436-5.296-5.431-5.296zM38.707 25.95c0 1.469-1.225 2.664-2.732 2.664h-29.794c-1.506 0-2.732-1.195-2.732-2.664v-14.59l15.178 8.205c0.767 0.415 1.609 0.622 2.45 0.622s1.683-0.207 2.451-0.622l15.178-8.205v14.59zM38.707 8.351l-16.487 8.912c-0.715 0.387-1.569 0.387-2.284 0l-16.487-8.912v-2.301c0-1.469 1.225-2.664 2.732-2.664h29.794c1.506 0 2.732 1.195 2.732 2.664v2.301z',
      },
    ],
  },
  phoneAcura: {
    viewBoxWidth: 32,
    viewBoxHeight: 32,
    paths: [
      {
        d: 'M30.152 20.724l-3.554-2.433c-0.475-0.324-1.011-0.548-1.576-0.657s-1.145-0.103-1.707 0.020c-0.562 0.123-1.093 0.359-1.56 0.694s-0.862 0.762-1.159 1.254l-0.857 1.45c-0.065 0.109-0.167 0.19-0.288 0.227s-0.252 0.029-0.366-0.025c-1.747-0.972-3.352-2.179-4.77-3.587-1.401-1.415-2.602-3.016-3.57-4.757-0.057-0.114-0.067-0.246-0.029-0.368s0.121-0.225 0.232-0.287l1.45-0.873c0.492-0.295 0.919-0.688 1.254-1.155s0.571-0.996 0.694-1.557c0.123-0.561 0.129-1.141 0.020-1.705s-0.333-1.099-0.657-1.573l-2.432-3.556c-0.347-0.48-0.786-0.886-1.292-1.194s-1.069-0.51-1.655-0.596c-0.586-0.086-1.183-0.053-1.756 0.096s-1.11 0.412-1.58 0.773l-2.12 1.404c-1.187 0.771-2.081 1.92-2.536 3.261s-0.446 2.797 0.026 4.132c1.794 5.053 4.71 9.633 8.527 13.397 3.77 3.809 8.346 6.724 13.391 8.531 0.665 0.24 1.367 0.361 2.073 0.359 1.052-0.002 2.087-0.265 3.012-0.766s1.711-1.224 2.289-2.104l1.419-2.121c0.365-0.468 0.631-1.006 0.782-1.579s0.185-1.173 0.099-1.76c-0.086-0.587-0.29-1.151-0.599-1.658s-0.718-0.945-1.202-1.289z',
      },
    ],
  },
  phoneHonda: {
    viewBoxWidth: 32,
    viewBoxHeight: 32,
    paths: [
      {
        strokeLinejoin: 'miter',
        strokeLinecap: 'butt',
        strokeMiterlimit: '4',
        strokeWidth: '0.8381',
        haveFill: true,
        d: 'M31.516 25.16c-0.025-1.25-0.536-2.24-1.454-2.855l-4.827-3.42c-0.431-0.295-0.827-0.51-1.198-0.665-0.431-0.175-0.847-0.265-1.273-0.265-1.423 0.005-2.471 1.070-3.308 1.925-0.18 0.18-0.351 0.36-0.521 0.515-2.516-1.55-5.659-4.62-7.364-7.35 0.125-0.135 0.281-0.29 0.446-0.46 0.586-0.595 1.248-1.265 1.564-1.855 0.526-0.88 0.576-1.82 0.155-2.785-0.165-0.4-0.391-0.8-0.692-1.215l-3.368-4.73c-0.662-0.94-1.739-1.49-2.963-1.5-2.211 0.175-4.045 1.39-5.123 3.355-1.449 2.645-1.429 6.52 0.040 9.41 4.17 8.45 12.737 17.465 22.462 18.235 3.464 0.005 7.263-2.52 7.424-6.34zM24.087 29.5c-8.868-0.82-16.758-9.215-20.662-17.13-1.173-2.315-1.208-5.495-0.075-7.56 0.747-1.365 1.89-2.14 3.399-2.31 0.341 0.010 0.917 0.12 1.288 0.65l3.379 4.745c0.21 0.29 0.366 0.555 0.476 0.83 0.21 0.485 0.115 0.75-0.070 1.055-0.17 0.33-0.812 0.98-1.233 1.405-0.191 0.195-0.371 0.375-0.511 0.53-0.586 0.57-0.687 1.485-0.256 2.35 1.88 2.945 5.263 6.29 8.035 8.030 0.717 0.42 1.774 0.47 2.436-0.23 0.191-0.175 0.391-0.375 0.592-0.585 0.611-0.62 1.303-1.325 1.88-1.325 0.155 0 0.321 0.035 0.506 0.115 0.246 0.1 0.516 0.25 0.817 0.455l4.832 3.42c0.241 0.16 0.561 0.46 0.586 1.21-0.171 2.52-2.963 4.345-5.419 4.345z',
      },
    ],
  },
  play: {
    viewBoxWidth: 32,
    viewBoxHeight: 32,
    paths: [
      {
        d: 'M23.25 16l-11.6 7.25v-14.5l11.6 7.25z',
      },
      {
        strokeLinejoin: 'miter',
        strokeLinecap: 'butt',
        strokeMiterlimit: '4',
        strokeWidth: '2.6667',
        d: 'M30.5 16c0 8.008-6.492 14.5-14.5 14.5s-14.5-6.492-14.5-14.5c0-8.008 6.492-14.5 14.5-14.5s14.5 6.492 14.5 14.5z',
      },
    ],
  },
  get playAcura() {
    return this.play;
  },
  get playHonda() {
    return this.play;
  },
  redirectBlank: {
    viewBoxWidth: 32,
    viewBoxHeight: 32,
    paths: [
      {
        strokeLinejoin: 'round',
        strokeLinecap: 'round',
        strokeMiterlimit: '4',
        strokeWidth: '4.5',
        d: 'M22.858 24.732v5.268h-20.694v-20.694h4.606',
      },
      {
        strokeLinejoin: 'round',
        strokeLinecap: 'round',
        strokeMiterlimit: '4',
        strokeWidth: '4',
        d: 'M13.66 18.177l16.176-16.177M29.836 2h-14.633M29.836 2v14.633',
      },
    ],
  },
  get redirectBlankAcura() {
    return this.redirectBlank;
  },
  get redirectBlankHonda() {
    return this.redirectBlank;
  },
  searchAcura: {
    viewBoxWidth: 34,
    viewBoxHeight: 32,
    paths: [
      {
        d: 'M4.027 4.29c-5.369 5.369-5.369 14.068 0 19.438 4.971 4.971 12.795 5.34 18.189 1.107l6.902 6.902 2.382-2.382-6.905-6.905c4.208-5.393 3.831-13.198-1.13-18.159-5.369-5.369-14.068-5.369-19.438 0zM6.409 21.346c-4.054-4.054-4.054-10.619 0-14.673s10.619-4.054 14.673 0c4.054 4.054 4.054 10.619 0 14.673s-10.619 4.054-14.673 0z',
      },
    ],
  },
  searchHonda: {
    viewBoxWidth: 32,
    viewBoxHeight: 32,
    paths: [
      {
        d: 'M4.267 4.187c-5.583 5.583-5.583 14.628 0 20.211 5.168 5.168 13.303 5.552 18.912 1.151l5.938 5.938c0.684 0.684 1.793 0.684 2.477 0s0.684-1.793 0-2.477l-5.941-5.941c4.375-5.608 3.983-13.723-1.176-18.882-5.583-5.583-14.628-5.583-20.211 0zM6.744 21.921c-4.215-4.215-4.215-11.042 0-15.257s11.042-4.215 15.257 0c4.215 4.215 4.215 11.042 0 15.257s-11.042 4.215-15.257 0z',
      },
    ],
  },
  searchAlternative: {
    viewBoxWidth: 32,
    viewBoxHeight: 32,
    paths: [
      {
        d: 'M22.87 20.126h-1.445l-0.512-0.494c1.793-2.086 2.872-4.794 2.872-7.739 0-6.568-5.324-11.893-11.893-11.893s-11.893 5.324-11.893 11.893c0 6.568 5.324 11.892 11.893 11.892 2.946 0 5.654-1.079 7.739-2.872l0.494 0.512v1.445l9.148 9.13 2.726-2.726-9.13-9.148zM11.893 20.126c-4.556 0-8.233-3.678-8.233-8.233s3.678-8.233 8.233-8.233c4.556 0 8.233 3.678 8.233 8.233s-3.678 8.233-8.233 8.233z',
      },
      {
        strokeLinejoin: 'miter',
        strokeLinecap: 'butt',
        strokeMiterlimit: '4',
        strokeWidth: '0.3333',
        d: 'M21.266 20.29l0.066 0.064h1.443l8.901 8.919-2.403 2.403-8.919-8.901v-1.443l-0.708-0.734-0.164 0.141c-2.046 1.759-4.701 2.817-7.59 2.817-6.442 0-11.664-5.222-11.664-11.664s5.222-11.664 11.664-11.664c6.442 0 11.664 5.222 11.664 11.664 0 2.889-1.058 5.544-2.817 7.59l-0.141 0.164 0.668 0.644zM3.431 11.893c0 4.682 3.78 8.462 8.462 8.462s8.462-3.78 8.462-8.462c0-4.682-3.78-8.462-8.462-8.462s-8.462 3.78-8.462 8.462z',
      },
    ],
  },
  get searchAlternativeAcura() {
    return this.searchAlternative;
  },
  get searchAlternativeHonda() {
    return this.searchAlternative;
  },
  userAcura: {
    viewBoxWidth: 32,
    viewBoxHeight: 32,
    paths: [
      {
        d: 'M16 0c4.42 0 8 3.58 8 8s-3.58 8-8 8c-4.42 0-8-3.58-8-8s3.58-8 8-8zM20 8c0-2.2-1.8-4-4-4s-4 1.8-4 4c0 2.2 1.8 4 4 4s4-1.8 4-4zM28 26c-0.4-1.42-6.6-4-12-4s-11.6 2.58-12 4.020v1.98h24v-2zM0 26c0-5.32 10.66-8 16-8s16 2.68 16 8v6h-32v-6z',
      },
    ],
  },
  userHonda: {
    viewBoxWidth: 34,
    viewBoxHeight: 32,
    paths: [
      {
        d: 'M12.661 8.021c0-2.448 1.985-4.433 4.433-4.433s4.433 1.985 4.433 4.433c0 2.448-1.985 4.433-4.433 4.433s-4.433-1.985-4.433-4.433zM17.094 0.043c-4.407 0-7.979 3.572-7.979 7.979s3.572 7.979 7.979 7.979c4.407 0 7.979-3.572 7.979-7.979s-3.572-7.979-7.979-7.979zM12.661 17.773c-6.855 0-12.411 5.557-12.411 12.411 0 0.979 0.794 1.773 1.773 1.773s1.773-0.794 1.773-1.773c0-4.896 3.969-8.865 8.865-8.865h8.865c4.896 0 8.865 3.969 8.865 8.865 0 0.979 0.794 1.773 1.773 1.773s1.773-0.794 1.773-1.773c0-6.855-5.557-12.411-12.411-12.411h-8.865z',
      },
    ],
  },
  warning: {
    viewBoxWidth: 32,
    viewBoxHeight: 32,
    paths: [
      {
        d: 'M16 24q0.68 0 1.14-0.46t0.46-1.14-0.46-1.14-1.14-0.46-1.14 0.46-0.46 1.14 0.46 1.14 1.14 0.46zM14.4 17.6h3.2v-9.6h-3.2v9.6zM16 32q-3.32 0-6.24-1.26t-5.080-3.42-3.42-5.080-1.26-6.24 1.26-6.24 3.42-5.080 5.080-3.42 6.24-1.26 6.24 1.26 5.080 3.42 3.42 5.080 1.26 6.24-1.26 6.24-3.42 5.080-5.080 3.42-6.24 1.26zM16 28.8q5.36 0 9.080-3.72t3.72-9.080-3.72-9.080-9.080-3.72-9.080 3.72-3.72 9.080 3.72 9.080 9.080 3.72z',
      },
    ],
  },
  get warningAcura() {
    return this.warning;
  },
  get warningHonda() {
    return this.warning;
  },
  location: {
    viewBoxWidth: 32,
    viewBoxHeight: 32,
    paths: [
      {
        d: 'M16 0c-6.192 0-11.2 5.008-11.2 11.2 0 8.4 11.2 20.8 11.2 20.8s11.2-12.4 11.2-20.8c0-6.192-5.008-11.2-11.2-11.2zM8 11.2c0-4.416 3.584-8 8-8s8 3.584 8 8c0 4.608-4.608 11.504-8 15.808-3.328-4.272-8-11.248-8-15.808z',
      },
      {
        d: 'M16 15.2c2.209 0 4-1.791 4-4s-1.791-4-4-4c-2.209 0-4 1.791-4 4s1.791 4 4 4z',
      },
    ],
  },
  get locationAcura() {
    return this.location;
  },
  get locationHonda() {
    return this.location;
  },
  plug: {
    viewBoxWidth: 32,
    viewBoxHeight: 32,
    paths: [
      {
        d: 'M13 12c0 1.657-1.343 3-3 3s-3-1.343-3-3c0-1.657 1.343-3 3-3s3 1.343 3 3z',
      },
      {
        d: 'M10 18.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z',
      },
      {
        d: 'M25 18.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z',
      },
      {
        d: 'M16 26c1.657 0 3-1.343 3-3s-1.343-3-3-3c-1.657 0-3 1.343-3 3s1.343 3 3 3z',
      },
      {
        d: 'M22 15c1.657 0 3-1.343 3-3s-1.343-3-3-3c-1.657 0-3 1.343-3 3s1.343 3 3 3z',
      },
      {
        d: 'M32 16c0-8.837-7.163-16-16-16s-16 7.163-16 16c0 8.837 7.163 16 16 16s16-7.163 16-16zM30 16c0 7.732-6.268 14-14 14s-14-6.268-14-14c0-7.732 6.268-14 14-14s14 6.268 14 14z',
      },
    ],
  },
  get plugAcura() {
    return this.plug;
  },
  get plugHonda() {
    return this.plug;
  },
  accesible: {
    viewBoxWidth: 32,
    viewBoxHeight: 32,
    paths: [
      {
        d: 'M16 6.4c1.767 0 3.2-1.433 3.2-3.2s-1.433-3.2-3.2-3.2c-1.767 0-3.2 1.433-3.2 3.2s1.433 3.2 3.2 3.2z',
      },
      {
        d: 'M27.2 17.6v-3.2c-2.464 0.032-4.944-1.2-6.512-2.928l-2.064-2.288c-0.272-0.304-0.608-0.544-0.976-0.72-0.016 0-0.016-0.016-0.032-0.016h-0.016c-0.56-0.32-1.2-0.48-1.904-0.416-1.68 0.144-2.896 1.632-2.896 3.312v9.456c0 1.76 1.44 3.2 3.2 3.2h8v8h3.2v-8.8c0-1.76-1.44-3.2-3.2-3.2h-4.8v-5.52c2.064 1.712 5.2 3.104 8 3.12zM12.8 28.8c-2.656 0-4.8-2.144-4.8-4.8 0-2.096 1.344-3.856 3.2-4.528v-3.312c-3.648 0.736-6.4 3.968-6.4 7.84 0 4.416 3.584 8 8 8 3.872 0 7.104-2.752 7.84-6.4h-3.312c-0.656 1.856-2.432 3.2-4.528 3.2z',
      },
    ],
  },
  get accesibleAcura() {
    return this.accesible;
  },
  get accesibleHonda() {
    return this.accesible;
  },
  parking: {
    viewBoxWidth: 32,
    viewBoxHeight: 32,
    paths: [
      {
        d: 'M16.889 0h-12.444v32h7.111v-10.667h5.333c5.884 0 10.667-4.782 10.667-10.667s-4.782-10.667-10.667-10.667zM17.244 14.222h-5.689v-7.111h5.689c1.956 0 3.556 1.6 3.556 3.556s-1.6 3.556-3.556 3.556z',
      },
    ],
  },
  get parkingAcura() {
    return this.parking;
  },
  get parkingHonda() {
    return this.parking;
  },
  refreshAcura: {
    viewBoxWidth: 20,
    viewBoxHeight: 20,
    paths: [
      {
        haveFill: true,
        d: 'M14.7041 5.29168C13.4957 4.08334 11.8374 3.33334 9.99574 3.33334C6.3124 3.33334 3.3374 6.31668 3.3374 10C3.3374 13.6833 6.3124 16.6667 9.99574 16.6667C13.1041 16.6667 15.6957 14.5417 16.4374 11.6667H14.7041C14.0207 13.6083 12.1707 15 9.99574 15C7.2374 15 4.99574 12.7583 4.99574 10C4.99574 7.24168 7.2374 5.00001 9.99574 5.00001C11.3791 5.00001 12.6124 5.57501 13.5124 6.48334L10.8291 9.16668H16.6624V3.33334L14.7041 5.29168Z',
      },
    ],
  },
  restroom: {
    viewBoxWidth: 32,
    viewBoxHeight: 32,
    paths: [
      {
        d: 'M4.8 32v-12h-2.4v-8.8c0-1.76 1.44-3.2 3.2-3.2h4.8c1.76 0 3.2 1.44 3.2 3.2v8.8h-2.4v12h-6.4zM24.8 32v-9.6h4.8l-4.064-12.208c-0.448-1.312-1.664-2.192-3.040-2.192h-0.192c-1.376 0-2.608 0.88-3.040 2.192l-4.064 12.208h4.8v9.6h4.8zM8 6.4c1.776 0 3.2-1.424 3.2-3.2s-1.424-3.2-3.2-3.2c-1.776 0-3.2 1.424-3.2 3.2s1.424 3.2 3.2 3.2zM22.4 6.4c1.776 0 3.2-1.424 3.2-3.2s-1.424-3.2-3.2-3.2c-1.776 0-3.2 1.424-3.2 3.2s1.424 3.2 3.2 3.2z',
      },
    ],
  },
  get restroomAcura() {
    return this.restroom;
  },
  get restroomHonda() {
    return this.restroom;
  },
  wifi: {
    viewBoxWidth: 32,
    viewBoxHeight: 32,
    paths: [
      {
        d: 'M0 11.311l2.909 2.909c7.229-7.229 18.953-7.229 26.182 0l2.909-2.909c-8.829-8.829-23.156-8.829-32 0zM11.636 22.947l4.364 4.364 4.364-4.364c-2.4-2.415-6.313-2.415-8.727 0zM5.818 17.129l2.909 2.909c4.015-4.015 10.531-4.015 14.545 0l2.909-2.909c-5.615-5.615-14.735-5.615-20.364 0z',
      },
    ],
  },
  get wifiAcura() {
    return this.wifi;
  },
  get wifiHonda() {
    return this.wifi;
  },
  store: {
    viewBoxWidth: 32,
    viewBoxHeight: 32,
    paths: [
      {
        d: 'M9.597 25.596c-1.759 0-3.183 1.439-3.183 3.199s1.423 3.199 3.183 3.199c1.759 0 3.199-1.439 3.199-3.199s-1.439-3.199-3.199-3.199zM25.591 25.596c-1.759 0-3.183 1.439-3.183 3.199s1.423 3.199 3.183 3.199c1.759 0 3.199-1.439 3.199-3.199s-1.439-3.199-3.199-3.199zM23.271 17.599c1.2 0 2.255-0.656 2.799-1.647l5.726-10.38c0.592-1.056-0.176-2.367-1.392-2.367h-23.671l-1.503-3.199h-5.23v3.199h3.199l5.758 12.139-2.159 3.903c-1.168 2.143 0.368 4.75 2.799 4.75h19.193v-3.199h-19.193l1.759-3.199h11.916zM8.253 6.404h19.433l-4.414 7.997h-11.228l-3.791-7.997z',
      },
    ],
  },
  get storeAcura() {
    return this.store;
  },
  get storeHonda() {
    return this.store;
  },
};

export type IconDefinitionKeys =
  | 'arrowDown'
  | 'arrowRight'
  | 'block'
  | 'bolt'
  | 'boltOutlined'
  | 'check'
  | 'circleCheck'
  | 'circleMinus'
  | 'close'
  | 'cross'
  | 'document'
  | 'download'
  | 'globe'
  | 'hamburguer'
  | 'info'
  | 'lock'
  | 'link'
  | 'mail'
  | 'phone'
  | 'play'
  | 'redirect'
  | 'redirectBlank'
  | 'search'
  | 'searchAlternative'
  | 'user'
  | 'warning'
  | 'location'
  | 'plug'
  | 'accesible'
  | 'parking'
  | 'refresh'
  | 'restroom'
  | 'wifi'
  | 'store';

export default iconDefinition as {
  [key in keyof typeof iconDefinition]: IconDefinitionProps;
};
